import axios from "axios";

interface ApiErrorPayload {
  detail?: string;
  message?: string;
  error?: string;
}

/** Extracts a human-readable message from a caught API error, without resorting to `any`. */
export function getErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as ApiErrorPayload | undefined;
    return data?.detail || data?.message || data?.error || error.message || fallback;
  }
  if (error instanceof Error) {
    return error.message || fallback;
  }
  return fallback;
}
